export const readFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    let onLoad, onError;

    const cleanup = () => {
      reader.removeEventListener('load', onLoad);
      reader.removeEventListener('error', onError);
    };

    onLoad = () => {
      resolve(reader.result);
      cleanup();
    };

    onError = (error) => {
      reject(error);
      cleanup();
    };

    reader.addEventListener('load', onLoad);
    reader.addEventListener('error', onError);
    reader.readAsDataURL(file);
  });
